import socket, { invokeRPC } from './socket.js'

export function createNotification(data) {
  return invokeRPC('notifications', 'createNotification', data)
}

export function getNotificationsForCustomer(customerId) {
  return invokeRPC('notifications', 'getNotificationsForCustomer', { customer_id: customerId })
}

export function clearNotificationsForCustomer(customerId) {
  return invokeRPC('notifications', 'clearNotificationsForCustomer', { customer_id: customerId })
}

export function getAllNotifications() {
  return invokeRPC('notifications', 'getAllNotifications')
}
